import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { FC } from 'react';
import { CompanyFullInfo, CompanyInfo } from 'src/pages/MainPage/_BLL/types';
import { TablePDF } from './TablePDF';
import { TITLE_COLOR } from '../consts';

const styles = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		height: '100%',
	},
	title: {
		fontSize: 14,
		color: TITLE_COLOR,
		marginBottom: 4,
	},
	name: {
		fontSize: 20,
	},
});

export const Page1: FC<Pick<CompanyFullInfo, 'name' | 'properties'>> = ({ name, properties }) => {
	const {
		overallDiversityAbsoluteRating,
		overallDiversityRelativeRating,

		boardDiversityAbsoluteRating,
		boardDiversityRelativeRating,

		executiveDiversityAbsoluteRating,
		executiveDiversityRelativeRating,

		genderDiversityAbsoluteRating,
		genderDiversityRelativeRating,

		raceEthnicityDiversityAbsoluteRating,
		raceEthnicityDiversityRelativeRating,

		ageDiversityAbsoluteRating,
		ageDiversityRelativeRating,

		disabilityDiversityAbsoluteRating,
		disabilityDiversityRelativeRating,

		womanWomenOwnership,
		womanWomenCEO,

		racialMinorityOwnership,
		racialMinorityCEO,

		veteranOwnership,
		veteranCEO,

		disabilityOwnership,
		disabilityCEO,

		lgbtqOwnership,
		lgbtqCEO,

		socialImpact,
		sme,
		sociallyDisadvantaged,
	} = properties;

	return (
		<View style={styles.container}>
			<View>
				<Text style={styles.title}>Certificate is valid for</Text>
				<Text style={styles.name}>{name}</Text>
			</View>

			<TablePDF<'name' | 'absoluteRating' | 'relativeRating'>
				title="Diversity by performance"
				columns={[
					{
						id: 'name',
						name: '',
					},
					{
						id: 'absoluteRating',
						name: 'Absolute rating',
					},
					{
						id: 'relativeRating',
						name: 'Relative rating',
					},
				]}
				data={[
					{
						item: {
							name: 'Overall Diversity',
							absoluteRating: overallDiversityAbsoluteRating,
							relativeRating: overallDiversityRelativeRating,
						},
					},
					{
						item: {
							name: 'Board Diversity',
							absoluteRating: boardDiversityAbsoluteRating,
							relativeRating: boardDiversityRelativeRating,
						},
					},
					{
						item: {
							name: 'Executive Diversity',
							absoluteRating: executiveDiversityAbsoluteRating,
							relativeRating: executiveDiversityRelativeRating,
						},
					},
					{
						item: {
							name: 'Gender',
							absoluteRating: genderDiversityAbsoluteRating,
							relativeRating: genderDiversityRelativeRating,
						},
					},
					{
						item: {
							name: 'Race/Ethnicity',
							absoluteRating: raceEthnicityDiversityAbsoluteRating,
							relativeRating: raceEthnicityDiversityRelativeRating,
						},
					},
					{
						item: {
							name: 'Age',
							absoluteRating: ageDiversityAbsoluteRating,
							relativeRating: ageDiversityRelativeRating,
						},
					},
					{
						item: {
							name: 'Disability',
							absoluteRating: disabilityDiversityAbsoluteRating,
							relativeRating: disabilityDiversityRelativeRating,
						},
					},
				]}
			/>

			<TablePDF<'name' | 'ownership' | 'ceo'>
				title="Diversity by ownership & leadership"
				columns={[
					{
						id: 'name',
						name: '',
					},
					{
						id: 'ownership',
						name: 'Ownership',
					},
					{
						id: 'ceo',
						name: 'CEO',
					},
				]}
				data={[
					{
						item: {
							name: 'Women',
							ownership: womanWomenOwnership,
							ceo: womanWomenCEO,
						},
					},
					{
						item: {
							name: 'Racial Minority',
							ownership: racialMinorityOwnership,
							ceo: racialMinorityCEO,
						},
					},
					{
						item: {
							name: 'Veteran',
							ownership: veteranOwnership,
							ceo: veteranCEO,
						},
					},
					{
						item: {
							name: 'LGBTQ',
							ownership: lgbtqOwnership,
							ceo: lgbtqCEO,
						},
					},
					{
						item: {
							name: 'Disability',
							ownership: disabilityOwnership,
							ceo: disabilityCEO,
						},
					},
				]}
			/>

			<TablePDF<'socialImpact' | 'sme' | 'sociallyDisadvantaged'>
				title="Diversity by ownership & leadership"
				columns={[
					{
						id: 'socialImpact',
						name: 'Social Impact',
					},
					{
						id: 'sme',
						name: 'SME',
					},
					{
						id: 'sociallyDisadvantaged',
						name: 'Socially Disadvantaged',
					},
				]}
				data={[
					{
						item: {
							socialImpact,
							sme,
							sociallyDisadvantaged,
						},
					},
				]}
			/>
		</View>
	);
};
